import { render } from "./MsgTips.vue?vue&type=template&id=682486be"
import script from "./MsgTips.vue?vue&type=script&lang=js"
export * from "./MsgTips.vue?vue&type=script&lang=js"

import "./MsgTips.vue?vue&type=style&index=0&id=682486be&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__